module.exports = "/_next/static/images/Hero-d98aa386b75097491ba096de64c54b7b.webp";